import {
    onUpdateTenantById,
} from '../../subscriptions';
import { recalculateDaPerformanceData } from '@/views/DaPerformanceReport/calculateDaPerformanceReport'
import store from '@/store'
import { initializeSubscription, disconnectSubscription, updateElement, updateRenderKey, getDifferentProperties } from '../helper'
import EventBus from '@/eventBus'

"use strict";
let subscriptionTenant = null

export const tenantSubscribe = function(instance){
    const queries = {
        onUpdateTenantById,
    }
    if(!store.state.userInfo?.tenant?.id) return
    const input = {
        id: store.state.userInfo.tenant.id
    }
    initializeSubscription(subscriptionTenant, queries, input, "subscriptionStore/handleTenant", instance)
}

export const config = function(subscriptions){
    const subscription = {}
    subscriptionTenant = subscriptions['tenant'] = {
        loadList: null,
        subscribe: tenantSubscribe,
        unsubscribe: (instance) => disconnectSubscription(subscription, instance),
        callback: tenantEventCallback,
        subscription
    }
}

export const tenantEventCallback = async function(subscriptionState, { data: tenant }){
    const currentTenant = store.state.userInfo.tenant

    const differences = getDifferentProperties(currentTenant, tenant)

    const featureChecklistPermissionFields = [
        'featureAccessRosterChecklist',
        'featureEnabledRosterChecklist',
        'permissionRosterChecklist'
    ]

    const featurePermissionFields = [
        'featureAccessVehiclePhotoLogsHeraAi',
        'featureEnabledVehiclePhotoLogsHeraAi',
        'permissionVehiclePhotoLogsHeraAi',
        'permissionHeraAi',
        'featureAccessInventoryManagement',
        'featureEnabledInventoryManagement',
        'permissionInventoryManagement',
        'featureAccessVehiclePhotoLogReview',
        'featureEnabledVehiclePhotoLogReview',
        ...featureChecklistPermissionFields
    ]

    const ivrNavFields = [
        'featureAccessPhoneAutomation',
        'featureEnabledPhoneAutomation',
        'featureAccessHeraMessenger2',
        'featureEnabledHeraMessenger2'
    ]

    const tenantUpdated = updateElement(currentTenant, tenant, true)
    if(tenantUpdated.__ob__){
        updateRenderKey(tenantUpdated.__ob__)
    }

    // HERA-8599: the main-nav "Messages & Phone Calls" title and the Phone
    // Automation item in Company Settings read these tenant flags through a
    // method (getNavTitle / isIvrEnabled), which the in-place scalar merge above
    // does not reliably re-render. When an IVR-nav flag changes, replace the
    // tenant object reference so the navigation updates live without a manual
    // page refresh.
    if(differences.some(key => ivrNavFields.includes(key))){
        store.commit('setTenant', { ...currentTenant })
    }

    let field
    if(field = differences.find(key => featurePermissionFields.includes(key))){
        if(
            featureChecklistPermissionFields.includes(field) &&
            tenantUpdated.featureAccessRosterChecklist &&
            tenantUpdated.featureEnabledRosterChecklist &&
            tenantUpdated.permissionRosterChecklist
        ){
            EventBus.$emit('reload-rchecklist')
        }
    }else{
        store.commit('setTenantCoachingInfo', tenant)
        await recalculateDaPerformanceData(true)
    }

}